import React, { useRef, useState, useEffect } from "react";
import videojs from "video.js";
import { Docubytes } from "../../Model/Content"; //Include Home
import { SVGIcons, ImgIcons } from "../../Helpers/Common";
import Stories, { WithSeeMore } from "react-insta-stories";
import { Swiper, SwiperSlide } from "swiper/react";
import { Mobilemenu } from "../Mobile_menu/Mobilemenu";
import { Pagination } from "swiper";
import $ from "jquery";
import BarLoader from "react-spinners/BarLoader";
var ImageData = "";
var SVGIcon = "";

ImgIcons().then((result) => (ImageData = result));
SVGIcons().then((resultData) => (SVGIcon = resultData));

export default function DocubytesSwiper({
  channel,
  song,
  url,
  likes,
  comment,
  shares,
  Videodata,
}) {
  const [isVideoPlaying, setisVideoPlaying] = useState(false);
  const [player, setPlayer] = useState(false);
  const [scrollstatus, setscrollstatus] = useState(false);
  const [Docubytescontent, setDocubytescontent] = useState(false);
  const [playurl, setplayurl] = useState("");
  var vidRef = useRef([]);
  const swiperRef = useRef(null)
  const onVideoClick = () => {
    if (isVideoPlaying) {
      setisVideoPlaying(false);
    } else {
      vidRef.current.play();
      setisVideoPlaying(true);
    }
  };
  // variable

  // HTML5 vdo object

  function isBottom(el) {
    return el.getBoundingClientRect().bottom <= window.innerHeight;
  }

  useEffect(() => {
    getData();
  }, []);
  const getData = () => {
    Docubytes(0, 100).then((res) => {
      console.log(res.data);
      setDocubytescontent(res.data);
     
    });
  };

  if (Docubytescontent == false) {
    // return <div className="loader"></div>;
    return <div className="loader"><BarLoader color="#ff000f" /></div>;
  }

  function getswiper(activeIndex, snapIndex, previousIndex, realIndex) {
    console.log("heheheheh")
    setPlayer(false);
    console.log(activeIndex, snapIndex, previousIndex, realIndex);
    if (Docubytescontent) {
      var Content = Docubytescontent.message.contents;
      var Videodata = Content[activeIndex];
      var Previousvideo = Content[activeIndex - 1];
    }

    if (activeIndex > previousIndex) {
      console.log("scroll down");

      var Previousvideo = Content[activeIndex - 1];
      if (vidRef.current[Previousvideo.ID]) {
        const p1 = videojs(vidRef.current[Previousvideo.ID]);
        p1.pause();
        p1.currentTime(0);
      }

      setplayurl(Videodata.preview_url_vertical.preview_url1_vertical);

      var getplayers = videojs.getPlayers();
      var currentp = Videodata.ID;
      var allplayer = Object.keys(getplayers);

      if (allplayer.includes(Videodata.ID.toString())) {
        const dd = videojs(Videodata.ID.toString());

        //When ready, start playback
        dd.ready(function () {
          dd.play();
        });
      } else {
        var overrideNative = false;
        var videoJsOptions = {
          html5: {
            hls: {
              overrideNative: overrideNative
            },
            nativeVideoTracks: !overrideNative,
            nativeAudioTracks: !overrideNative,
            nativeTextTracks: !overrideNative
          },
          hls: {
              overrideNative: overrideNative
            },
          autoplay:true,
          autoPlay:true,
          kind: "captions",
          fluid: true,
          preload: "none",
          aspectRatio: "15:15",
          height: "auto",
          width: "100%",
          nativeControlsForTouch: false, //nativeControlsForTouch for player js
          disablePictureInPicture: false,
          controls: false,
          sources: [
            {
              src: Videodata.preview_url_vertical.preview_url1_vertical,
              type: "application/x-mpegURL",
              withCredentials: false,
            },
          ],
        };
        //var p = videojs(vidRef.current[Videodata.ID], "");
        var p = videojs(vidRef.current[Videodata.ID], videoJsOptions,  () => {
          
        p.play()
        setPlayer(p);
        console.log(player)

        if (!p.paused()) {
          console.log("Video is playing");
        } else {
          p.play()
          console.log("Video is paused");
        }
        /*if(p.paused()){
                    p.play()
                  }*/
        return () => {
          if (player) {
            player.dispose();
          }
        };
        });
        p.src([
                {
                    src: Videodata.preview_url_vertical.preview_url1_vertical,
                    type: 'application/x-mpegURL',
                }
            ]);
        setplayurl(Videodata.preview_url_vertical.preview_url1_vertical);
        p.play();

      }
    } else {
      console.log("scroll up");
      var Previousvideo = Content[activeIndex + 1];
      console.log(
        Previousvideo.ID + " -- Previous" + Videodata.ID + "-- Current"
      );
      if (vidRef.current[Previousvideo.ID]) {
        
        var p1 = videojs(vidRef.current[Previousvideo.ID]);
        p1.pause();
        p1.currentTime(0);
        var videoJsOptions = {
          html5: {
            hls: {
              overrideNative: overrideNative
            },
            nativeVideoTracks: !overrideNative,
            nativeAudioTracks: !overrideNative,
            nativeTextTracks: !overrideNative
          },
          hls: {
              overrideNative: overrideNative
            },
          autoplay:true,
          kind: "captions",
          preload: "none",
          aspectRatio: "15:15",
          height: "auto",
          width: "100%",
          nativeControlsForTouch: false, //nativeControlsForTouch for player js
          disablePictureInPicture: false,
          controls: false,
          sources: [
            {
              src: Videodata.preview_url_vertical.preview_url1_vertical,
              type: "application/x-mpegURL",
              withCredentials: false,
            },
          ],
        };
        setplayurl(Videodata.preview_url_vertical.preview_url1_vertical);

        /*const p1 = videojs(vidRef.current[Previousvideo.ID], videoJsOptions);
      p1.currentTime = 0;*/

        var p = videojs("#"+Videodata.ID);
        setPlayer(p);
        if(p){
          console.log(p.src)
          p.play();

        }else{
          console.log("play  nn")

          console.log(p.play());
            
        }
        
        
      } else {
        console.log("else con")
        var videoJsOptions = {
          html5: {
            hls: {
              overrideNative: overrideNative
            },
            nativeVideoTracks: !overrideNative,
            nativeAudioTracks: !overrideNative,
            nativeTextTracks: !overrideNative
          },
          hls: {
              overrideNative: overrideNative
            },
          autoplay:true,
          autoPlay:true,
          kind: "captions",
          preload: "none",
          aspectRatio: "15:15",
          height: "auto",
          width: "100%",
          controls: false,
          sources: [
            {
              src: Videodata.preview_url_vertical.preview_url1_vertical,
              type: "application/x-mpegURL",
              withCredentials: false,
            },
          ],
        };
         setplayurl(Videodata.preview_url_vertical.preview_url1_vertical);
        /*const p1 = videojs(vidRef.current[Previousvideo.ID], videoJsOptions);
      p1.currentTime = 0;*/
        var p = videojs(vidRef.current[Previousvideo.ID], videoJsOptions);
        setPlayer(p);
        return () => {
          if (player) player.dispose();
        };
        p.play();
      }
    }

    //console.log(vidRef.current)
  }

  return (
    <Swiper
      slidesPerView="1"
      mousewheel={true}
      direction="vertical"
      modules={[Pagination]}
      pagination={{ clickable: true }}
      scrollbar={{ draggable: true }}
      onSlideChange={(swiperCore) => {
        const { activeIndex, snapIndex, previousIndex, realIndex } = swiperCore;
        getswiper(activeIndex, snapIndex, previousIndex, realIndex);
      }}
      className="docubytes-swiper"
      ref={swiperRef}
    >
      {Docubytescontent.message.contents.map((list, i) => {
        //console.log(list.ID)
        return (
          <SwiperSlide key={i}>
            <main>
              <section className="mb-0">
                <div className="video-cards">
                  <video
                    src={list.preview_url_vertical.preview_url1_vertical}
                    onClick={onVideoClick}
                    className="video-player"
                    ref={(el) => (vidRef.current[list.ID] = el)}
                    id={list.ID}
                    playsInline={true}
                    webkit-playsinline={true}
                    webkit-playsinline={true}
                    webkit-playsinline=""
                    playsInline="" 
                    x-webkit-airplay="allow"
                    autoPlay
                  />
                </div>
                <div className="temp48">
                  <div className="temp48-area">
                    <div className="temp48-img">
                      <img src={SVGIcon["like-red.svg"]} />
                    </div>
                    <div className="temp48-text">1.5k</div>
                  </div>
                  <div className="temp48-area">
                    <div className="temp48-img">
                      <img src={SVGIcon["share.svg"]} />
                    </div>
                    <div className="temp48-text">Share</div>
                  </div>
                  <div className="temp48-area">
                    <div className="temp48-img">
                      <img src={SVGIcon["watchlist.svg"]} />
                    </div>
                    <div className="temp48-text">Watchlist</div>
                  </div>
                </div>
                <div className="temp49">
                  <div className="temp49-img">
                    {" "}
                    <img src={list.preview_image_1.original} alt="Docubytes" />
                  </div>
                  <div className="temp49-text">
                    <h6>{list.title}</h6>
                    <p>{list.genres}</p>
                  </div>
                </div>
              </section>
            </main>
          </SwiperSlide>
        );
      })}
    </Swiper>
  );
}
